import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverAssignmentFilterEntity } from '../../domain/entities/DriverAssignmentFilterEntity'

export class DriverAssignmentFilterModel extends DriverAssignmentFilterEntity {
  constructor(dataDto: DriverAssignmentFilterEntity) {
    super()
    mapEntityProperties<DriverAssignmentFilterModel>(this, dataDto)
  }
}
